export const BILLING_ENTITIES = ["seminare", "coaching", "praxis"] as const;

export type BillingEntity = (typeof BILLING_ENTITIES)[number];

const DEFAULT_ENTITY: BillingEntity = "coaching";

export function isBillingEntity(value: unknown): value is BillingEntity {
  return BILLING_ENTITIES.includes(String(value) as BillingEntity);
}

export function normalizeBillingEntity(value: unknown): BillingEntity {
  return isBillingEntity(value) ? value : DEFAULT_ENTITY;
}

export function allowsStripeOnline(entity: unknown): boolean {
  return normalizeBillingEntity(entity) === "seminare";
}

export function billingEntityFromOffer(input: {
  slug?: string | null;
  title?: string | null;
}): BillingEntity {
  const haystack = `${input.slug ?? ""} ${input.title ?? ""}`.toLowerCase();
  if (
    haystack.includes("bodywork") ||
    haystack.includes("naturheil") ||
    haystack.includes("praxisarbeit") ||
    haystack.includes("erstanamnese") ||
    /(^|[\s&-])praxis([\s&-]|$)/.test(haystack)
  ) {
    return "praxis";
  }
  if (
    haystack.includes("aufstellung") ||
    haystack.includes("seminar") ||
    haystack.includes("tadschalli") ||
    haystack.includes("teaching")
  ) {
    return "seminare";
  }
  return "coaching";
}

export function billingEntityLabel(entity: unknown): string {
  const normalized = normalizeBillingEntity(entity);
  if (normalized === "praxis") return "Schörling Naturheilpraxis";
  if (normalized === "coaching") return "Coaching";
  return "Schörling Seminare";
}
